import { styled } from '@mui/material/styles';

import Icon from '../../../Icon/Icon';
import { Tooltip, type TooltipProps } from '../../../Tooltip/Tooltip';

export interface DataGridColumnHeaderWithToolTipProps
  extends Omit<TooltipProps, 'title' | 'children'> {
  id: string;
  headerName: string;
  description: string;
}

const StyledColumnHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  overflow: 'hidden',
  padding: '16px 24px',
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

const StyledHeaderText = styled('div')(({ theme }) => ({
  whiteSpace: 'nowrap',
  fontSize: '14px',
  textOverflow: 'ellipsis',
  marginRight: theme.spacing(2),
}));

export const DataGridColumnHeaderWithToolTip = (props: DataGridColumnHeaderWithToolTipProps) => {
  const { id, headerName, description, placement = 'top', ...rest } = props;

  const tooltipId = `${id}-header-tooltip-${headerName.replace(/\s+/g, '').toLowerCase()}`;

  return (
    <StyledColumnHeader>
      <StyledHeaderText>{headerName}</StyledHeaderText>
      <Tooltip {...rest} id={tooltipId} title={description} placement={placement} arrow>
        <Icon id={`${tooltipId}-icon`} height={18} width={18} icon="info" />
      </Tooltip>
    </StyledColumnHeader>
  );
};
